import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme"; // Store Custom Code
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden"; // Store Custom Code
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct; // Store Custom Code

export interface ProductDetailsViewStyles {
    container?: GridContainerProps;
    leftColumnGridItem?: GridItemProps;
    leftColumnInnerContainer?: GridContainerProps;
    toptitleGridItem?: GridItemProps; // Store Custom Code
    topGridItem?: GridItemProps;
    middleGridItem?: GridItemProps;
    middleGridItemHidden?: HiddenProps;
    bottomGridItem?: GridItemProps;
    rightColumnGridItem?: GridItemProps;
    rightColumnGridItemHidden?: HiddenProps;
}

export const viewStyles: ProductDetailsViewStyles = {
    // Store Custom Code
    toptitleGridItem: {
        width: [12, 12, 0, 0, 0],
    },
    // Store Custom Code
    leftColumnGridItem: {
        width: [12, 12, 4, 4, 4],
        css: css`
            overflow: hidden;
        `,
    },
    // Store Custom Code
    topGridItem: {
        width: [12, 12, 0, 0, 0],
    },
    // Store Custom Code
    middleGridItem: {
        width: [12, 12, 0, 0, 0],
    },
    // Store Custom Code: Todo - Refactor external dev's bad code
    middleGridItemHidden: {
        above: "sm",
        css: css`
            width: 100%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            div div div div div div div {
                                height: auto;
                                display: inline-block;
                                flex-basis: 33% !important;
                                max-width: 33% !important;
                                padding: 0;
                            }
                            div div div div div div div div {
                                flex-basis: 100% !important;
                                max-width: 100% !important;
                            }
                        `,
                        css``,
                        css``,
                        css``,
                        css``,
                    ],
                    "max",
                )}
        `,
    },
    bottomGridItem: {
        width: [0, 0, 12, 12, 12],
        css: css``,
    },
    rightColumnGridItem: {
        width: [0, 0, 8, 8, 8],
        css: css`
            padding-left: 60px;
            text-align: left;
        `,
    },
    rightColumnGridItemHidden: {
        below: "md",
        css: css`
            width: 100%;
        `,
    },
};

const styles = viewStyles;

const ProductDetailsView: React.FC<Props> = props => {
    return (
        <GridContainer {...styles.container}>
            {/* Store Custom Code */}
            <GridItem {...styles.toptitleGridItem}>
                <Zone contentId={props.id} zoneName="Content4" />
            </GridItem>
            <GridItem {...styles.leftColumnGridItem} data-test-selector="productDetails_leftColumn">
                <GridContainer {...styles.leftColumnInnerContainer}>
                    <GridItem {...styles.topGridItem}>
                        <Zone contentId={props.id} zoneName="Content0" />
                    </GridItem>
                    <GridItem {...styles.middleGridItem}>
                        <Hidden {...styles.middleGridItemHidden}>
                            <Zone contentId={props.id} zoneName="Content1" />
                        </Hidden>
                    </GridItem>
                    <GridItem {...styles.bottomGridItem}>
                        <Zone contentId={props.id} zoneName="Content2" />
                    </GridItem>
                </GridContainer>
            </GridItem>
            {/* Store Custom Code */}
            <GridItem {...styles.rightColumnGridItem} data-test-selector="productDetails_rightColumn">
                <Hidden {...styles.rightColumnGridItemHidden}>
                    <Zone contentId={props.id} zoneName="Content3" />
                </Hidden>
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect()(withProduct(ProductDetailsView)),
    definition: {
        displayName: "View",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
